<template>
    <div class="card">
        <div class="card__title">
            <span>Eventos de autorización</span>
        </div>
        <div class="card__content">
            <div class="row">
                <div class="col-xs-12">
                    <div class="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>Tipo de ambiente</th>
                                    <th>Fecha</th>
                                    <th>Respuesta</th>
                                    <th>Tipo de evento</th>
                                    <th>Información adicional</th>
                                    <th>Identificador</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-show="eventos.length === 0">
                                    <td colspan="7">
                                        <strong>No se encontró eventos.</strong>
                                    </td>
                                </tr>
                                <tr :key="index" v-for="(evento, index) in eventos">
                                    <td>{{ evento.tipo_ambiente !== null?evento.tipo_ambiente.descripcion:'-' }}</td>
                                    <td>{{ evento.fecha }}</td>
                                    <td>{{ evento.respuesta }}</td>
                                    <td>{{ evento.tipo }}</td>
                                    <td>{{ evento.informacion_adicional }}</td>
                                    <td>{{ evento.identificador }}</td>
                                    <td>{{ evento.estado }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        idComprobante : {
            type : String,
            required : true
        }
    },
    data : function () {
        return {
            eventos : [],
            url : url
        };
    },
    methods : {
        cargarEventosComprobante : function () {
            let that = this;
            axios.get(this.url + '/autorizacion-documentos/' + this.idComprobante).then(function (response) {
                that.eventos = response.data;
            });
        }
    },
    mounted : function () {
        this.cargarEventosComprobante();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/EventosComprobante.vue